import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'
import Collapsable from '../Collapsable'
import DayButton from '../DayButton'
import Highlight from '../Highlight'
import PushMessage from '../PushMessage'
import PushPWAFunctionnalitySection from '../PushPWAFunctionnalitySection'
import PushPWATutoSection from '../PushPWATutoSection'

export const Collapse = styled(Collapsable)`
  .collapsable-content {
    padding-left: 0rem;
    padding-right: 0rem;

    @media ${mq(sizes.desktop)} {
      padding-left: 8rem;
      padding-right: 8rem;
    }
  }
`

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-wrap: wrap;

  &::first-letter {
    text-transform: uppercase;
  }

  @media ${mq(sizes.tablet)} {
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.titleH2_30}
  }
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3.5rem;
  justify-content: center;

  @media ${mq(sizes.desktop)} {
    margin-top: 2rem;
    align-items: center;
  }
`
export const Button = styled(ActionButton)`
  & .button-icon {
    flex-shrink: 0;
  }
`

export const ButtonsWrapper = styled.div<{ withBorder?: boolean }>`
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 0 2rem;
  gap: 1rem;

  ${Button} {
    justify-content: flex-start;

    & > * {
      width: 100%;
      justify-content: flex-start;
    }
  }

  @media ${mq(sizes.tablet)} {
    padding: 0 1rem;
    max-width: 110rem;
    padding-bottom: 3rem;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    border-bottom: ${({ theme, withBorder }) =>
      withBorder ? `0.2rem solid ${theme.colors.greyDD}` : 'none'};
  }
`

export const DayBtn = styled(DayButton)``

export const DaysWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-shrink: 0;
  overflow-x: auto;
  margin-top: 3rem;
  padding-left: 2rem;
  scrollbar-width: none; //FF

  ::-webkit-scrollbar {
    display: none;
  }

  @media ${mq(sizes.tablet)} {
    padding-left: 0;
    justify-content: center;
  }

  ${DayBtn} {
    display: inline-block;
    max-width: 4.5rem;
    min-width: 4.5rem;
    margin-left: 1rem;

    &:first-child {
      margin-left: 0;
    }

    @media ${mq(sizes.tablet)} {
      max-width: 12rem;
      min-width: 12rem;
    }
  }
`

export const CustomHighlight = styled(Highlight)`
  & span {
    display: flex;
    align-items: center;
  }
`

export const PushPWAFunctionnality = styled(PushPWAFunctionnalitySection)`
  margin: 0 2rem 4rem 2rem;
`

export const PushPWATuto = styled(PushPWATutoSection)`
  margin: 0 2rem 4rem 2rem;
`

export const CustomPushMessage = styled(PushMessage)`
  margin: 0 2rem 4rem 2rem;
`
